import { ShiftbookEntryTypeSchema } from '@blms/shared/schemas/shiftbook-entry';
import { z } from 'zod';
import { getSessionOwner, isSessionVerified } from '@/features/auth/session-boundary';

const KEY = 'blms-workspace-reauth-return';
const RecoverySchema = z.object({
  owner: z.string(),
  entryType: ShiftbookEntryTypeSchema,
  draftId: z.string().uuid(),
});
type CreateRecovery = Omit<z.infer<typeof RecoverySchema>, 'owner'>;
let current: z.infer<typeof RecoverySchema> | null = null;

export function trackCreateWorkspace(value: CreateRecovery | null) {
  const owner = getSessionOwner();
  current = value && owner ? { ...value, owner } : null;
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* Memory-only editing remains available. */
  }
}

export function prepareWorkspaceRecovery() {
  try {
    if (current && current.owner === getSessionOwner()) {
      sessionStorage.setItem(KEY, JSON.stringify(current));
    } else {
      sessionStorage.removeItem(KEY);
    }
  } catch {
    // Popup recovery still preserves the mounted editor when storage is blocked.
  }
}

export function restoreCreateWorkspace(): CreateRecovery | null {
  if (!isSessionVerified()) return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const result = RecoverySchema.safeParse(JSON.parse(raw));
    if (!result.success || result.data.owner !== getSessionOwner()) return null;
    return { entryType: result.data.entryType, draftId: result.data.draftId };
  } catch {
    return null;
  }
}
